import { format } from "date-fns";

export const formatDateForApi = (date) => format(date, "MM-dd-yyyy");

export const formatDateToReadable = (dateString) => {
  if (!dateString) return "";
  try {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  } catch {
    return dateString;
  }
};
